import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
export default {
  name: "user-real-name",
  data: function data() {
    return {
      authInfo: {},
      dialogVisible: false,
      imageRotateDialogVisible: false,
      rotateIndex: 0,
      imageRotateUrl: "",
      searchForm: {
        pn: 1,
        ps: 20,
        name: "",
        number: this.$route.query.number || ""
      },
      // 搜索表单

      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    closeRotateDialog: function closeRotateDialog() {
      this.imageRotateDialogVisible = false;
    },
    saveRotateImgUrl: function saveRotateImgUrl() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this2.$message.error("不支持旋转");
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    selectRotateImg: function selectRotateImg(index) {
      this.rotateIndex = index || 0;
      this.imageRotateUrl = this.authInfo.card_img[this.rotateIndex];
      this.imageRotateDialogVisible = true;
    },
    realNameInfoDialog: function realNameInfoDialog(row) {
      this.dialogVisible = true;
      this.authInfo = row;
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pn = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (type === "search") {
                _this3.searchForm.pn = 1;
              }
              _this3.tableLoading = true;
              _context3.n = 1;
              return _this3.$api.getRealNameUserList(_this3.searchForm);
            case 1:
              res = _context3.v;
              res.data.list.forEach(function (item) {
                item.auth_method = item.auth_method || [];
              });
              _this3.tableData = res.data.list;
              _this3.total = res.data.count;
              _this3.tableLoading = false;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    }
  }
};